import axios from "axios";

export const qriApi = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: `${process.env.REACT_APP_QRI_SERVICE_HOSTNAME}`,
  withCredentials: true,
});
